(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maliha-search-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
function initMalihaSearch(root){
root.querySelectorAll('.maliha-search-strip').forEach(function(el){
 if(el.dataset.initialized==='1')return;el.dataset.initialized='1';
 var input=el.querySelector('.maliha-search-strip__input'),area=el.querySelector('.maliha-search-strip__results'),timer=null,controller=null,seq=0;
 function hide(){area.hidden=true;area.replaceChildren();input.setAttribute('aria-expanded','false')}
 function show(products){
  area.replaceChildren();
  if(!products.length){var msg=document.createElement('p');msg.className='maliha-search-strip__empty';msg.textContent=el.dataset.empty;area.append(msg)}
  else{var list=document.createElement('ul');list.className='maliha-search-strip__list';
    products.forEach(function(p){var li=document.createElement('li');li.className='maliha-search-strip__result';var a=document.createElement('a');a.href=p.url;a.className='maliha-search-strip__link';
      var photo=p.featured_image;var url=typeof photo==='string'?photo:(photo&&photo.url);if(url){var image=document.createElement('img');image.src=url;image.alt='';image.loading='lazy';image.className='maliha-search-strip__image';a.append(image)}
      var name=document.createElement('span');name.textContent=p.title;a.append(name);li.append(a);list.append(li)});
    area.append(list)}
  area.hidden=false;input.setAttribute('aria-expanded','true');
 }
 input.addEventListener('input',function(){
   clearTimeout(timer);if(controller)controller.abort();var q=input.value.trim();var current=++seq;if(!q.length){hide();return}
   // Standard Shopify storefront search works in Arabic and English.
   // It starts with one character; predictive /search/suggest.json is unsupported in Arabic.
   timer=setTimeout(function(){controller=new AbortController();var params=new URLSearchParams();
     params.set('q',q);params.set('type','product');params.set('options[prefix]','last');params.set('view','maliha-live');
     var previewThemeId=new URLSearchParams(window.location.search).get('preview_theme_id');
     if(previewThemeId&&/^[0-9]+$/.test(previewThemeId))params.set('preview_theme_id',previewThemeId);
     fetch((el.dataset.root||'/')+'search?'+params.toString(),{signal:controller.signal,headers:{Accept:'application/json'}})
       .then(function(res){if(!res.ok)throw Error('Search unavailable');return res.json()})
       .then(function(data){if(current!==seq)return;show((data&&Array.isArray(data.products)?data.products:[]))})
       .catch(function(error){if(error.name!=='AbortError'&&current===seq)hide()});
   },260)
 });
 input.addEventListener('keydown',function(e){if(e.key==='Escape')hide()});
 document.addEventListener('pointerdown',function(e){if(!el.contains(e.target))hide()})
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initMalihaSearch(document)});else initMalihaSearch(document);
document.addEventListener('shopify:section:load',function(e){initMalihaSearch(e.target)})
})();

  } catch(e) { console.error(e); }
})();
})();
